import { EXERCISE_IMAGE_FILES } from "./exerciseImageManifest";

// Dal nome esercizio al base-slug: minuscolo, senza accenti, apostrofi e spazi -> trattini.
export function slugifyExercise(name) {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’\s]+/g, "-");
}

// Ritorna le immagini disponibili per un esercizio: due (inizio/fine), una, o nessuna.
export function getExerciseImages(name) {
  const s = slugifyExercise(name);
  const start = `${s}-inizio.png`;
  const end = `${s}-fine.png`;
  const single = `${s}.png`;
  if (EXERCISE_IMAGE_FILES.has(start) && EXERCISE_IMAGE_FILES.has(end)) {
    return [
      { src: `/esercizi/${start}`, alt: `${name} – inizio`, label: "Inizio" },
      { src: `/esercizi/${end}`, alt: `${name} – fine`, label: "Fine" },
    ];
  }
  if (EXERCISE_IMAGE_FILES.has(single)) {
    return [{ src: `/esercizi/${single}`, alt: name, label: null }];
  }
  return [];
}
